import React, {Component} from 'react'
import SysUserRight from './SysUserRight'
import SysUserInfo from './SysUserInfo'
import SysUserTopics from './SysUserTopics'
import SysUserMcpServices from './SysUserMcpServices'
import {
    Spin,
    Avatar, List,Tabs
} from 'antd';
import * as Icon from '@ant-design/icons';
import './index.less'
import {apiGetRequest} from "../../http/http";
export default class sysUserDetail extends Component {
    userInfoForm = React.createRef();
    sysUserRight = React.createRef();
    state = {
        userInfo:{},
        rolesList:[],
        resourcesList:[],
        resourceIdsList:[],
        topicIds:[],
        mcpServiceCodes:[],
        rightLoading:true,
    };
    initUserDetail = (userId)=>{
        this.setState({
            rightLoading:true,
        })
        apiGetRequest('lechun-baseservice/user/getUserRolesAndResources',{userId}).then(res=>{
            let resourcesList = this.resetTreeData(res.resources||[])
            this.setState({
                rightLoading:false,
                userInfo:res.user||{},
                rolesList:(res.roles||[]).map(item=>item.roleId),
                resourcesList:resourcesList,
                resourceIdsList:[],
                topicIds:(res.wenshuTopics||[]).map(item=>item.topicId),
                mcpServiceCodes:(res.mcpServices||[]).map(item=>item.serviceCode),
            })
            if(this.userInfoForm.current){
                this.userInfoForm.current.setFormParam(res.user)
            }
            if(this.sysUserRight.current){
                this.sysUserRight.current.resetForm(res.roleIds)
            }
        })
    }
    resetTreeData = (list)=>{
        return list.map((item) => {
            const baseItem = {
                ...item,
                key: item.resourceId,
                title: item.resourceName,
            }
            if(item.children && item.children.length > 0){
                return {
                    ...baseItem,
                    isLeaf: false,
                    children: this.resetTreeData(item.children)
                }
            }
            return {
                ...baseItem,
                icon:<Icon.FileTextFilled />,
                isLeaf: true,
                disabled:item.hasRight==1?false:true,
            }
        })
    }
    handleSaveUserInfo = (userId)=>{
        this.initUserDetail(userId)
    }
    resLoadRight = ()=>{
        this.initUserDetail(this.state.userInfo.userId)
    }

    render() {
        const { userInfo,rolesList,resourcesList,resourceIdsList} = this.state;
        return (
            <div className={'sys-user-detail'}>
                <div>
                    <List
                        size={'small'}
                        dataSource={[userInfo]}
                        renderItem={item => (
                            <List.Item
                                key={item.userId}>
                                <List.Item.Meta
                                    avatar={<Avatar src={item.avatar} size={40} />}
                                    title={item.userNick}
                                    description={item.userName}
                                />
                            </List.Item>
                        )}
                    />
                </div>
                <Tabs
                    defaultActiveKey="1"
                    items={[
                        {
                            label: `基本信息`,
                            key: '1',
                            children: <div className={'sys-user-detail-content'}>
                                <Spin spinning={this.state.rightLoading}>
                                    <SysUserInfo
                                        ref={this.userInfoForm}
                                        userInfo={userInfo}
                                        handleSaveUserInfo={this.handleSaveUserInfo}
                                    />
                                </Spin>
                            </div>,
                        },
                        {
                            label: `权限管理`,
                            key: '2',
                            children: <div className={'sys-user-detail-content'}>
                                <Spin spinning={this.state.rightLoading}>
                                    <SysUserRight
                                        ref={this.sysUserRight}
                                        userInfo={userInfo}
                                        rolesList={rolesList}
                                        resourcesList={resourcesList}
                                        resourceIdsList={resourceIdsList}
                                        resLoadRight={this.resLoadRight}
                                    />
                                </Spin>

                            </div>,
                        },
                        {
                            label: `问数主题`,
                            key: '3',
                            children: <div className={'sys-user-detail-content'}>
                                <Spin spinning={this.state.rightLoading}>
                                    <SysUserTopics
                                        userInfo={userInfo}
                                        selectedTopicIds={this.state.topicIds}
                                        onReload={this.resLoadRight}
                                    />
                                </Spin>
                            </div>,
                        },
                        {
                            label: `MCP`,
                            key: '4',
                            children: <div className={'sys-user-detail-content'}>
                                <Spin spinning={this.state.rightLoading}>
                                    <SysUserMcpServices
                                        userInfo={userInfo}
                                        selectedServiceCodes={this.state.mcpServiceCodes}
                                        onReload={this.resLoadRight}
                                    />
                                </Spin>
                            </div>,
                        },
                    ]}
                />
            </div>
        )
    }
}
